import { useNavigate } from 'react-router-dom';

import { API_BASE_URL } from '../config/config';
import { AuthClient, AuthDTO, ImpersonationDTO } from '../services/apiClient';
import axiosInstance from '../services/axiosInstance';
import { getAdminId } from '../utils/tokenUtils';

// Log out, and "Return to Admin" for an admin who is signed in as a member. Shared by the desktop
// ProfileMenu and the mobile profile Settings page, which replaces that menu on a phone.
export const useSessionActions = (): {
  adminId: string | null;
  logOut: () => void;
  returnToAdmin: () => Promise<void>;
} => {
  const navigate = useNavigate();
  const adminId = getAdminId();

  const logOut = (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    navigate('/login');
  };

  const returnToAdmin = async (): Promise<void> => {
    const impersonateDto: ImpersonationDTO = {
      adminId: adminId ?? '',
    };

    try {
      const response = await new AuthClient(
        API_BASE_URL,
        axiosInstance,
      ).impersonateMemberLogout(impersonateDto);

      if (response && response.success && response.data) {
        const responseData = response.data as AuthDTO;

        localStorage.setItem('token', responseData.accessToken ?? '');
        localStorage.setItem('refresh_token', responseData.refreshToken ?? '');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Error impersonating login as member', error);
    }
  };

  return { adminId, logOut, returnToAdmin };
};
